module.exports = __webpack_public_path__ + "img/iconfinder_facebook-social-media_765252.8819eff0.svg";